import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledAvpErrorWrapper = styled.div`
	z-index: 10;
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: #000;
	padding: 0 20px;
	${breakPoints({
		'768': `padding: 0;`,
	})};

	> p {
		color: #fff;
		margin-bottom: 20px;
		text-align: center;
		${breakPoints({
			'768': `text-align: left;`,
		})};
	}

	> button {
		background: #fff;
		font-weight: medium;
		&:hover {
			background: #fff;
		}
	}
`;
